import { getAssessementsBatch } from "api/customers";
import { ASSESSMENTS_BATCH } from "@constants/reactQueryKeys";
import { useQuery } from "react-query";

export const useGetAssessementsBatch = (params) => {
  return useQuery([ASSESSMENTS_BATCH, params], () => getAssessementsBatch(params), {
    keepPreviousData: true, // this is used to avoid flickering in assessments Libraries tab
  });
};
